import { setCookie, capitalize } from '@/Shared/helper.js'

import { useStore } from '@/store/bucket'
import { useFavoriteBrandsStore } from '@/store/favoriteBrands'
import { useFavoriteShopsStore } from '@/store/favoriteShops'
import { useCheckedBrandsStore } from '@/store/checkedBrands'
import { useCheckedShopsStore } from '@/store/checkedShops'

/**
 * お気に入りの状態を管理
 * @param {{
 * favorite?: reactive,
 * category: String,
 * slug: String,
 * }}
 * 以下の引数をオブジェクトに格納
 * @param favorite この関数を使用するファイルからその状態を渡すためのreactiveオブジェクト    
 * 使用例：    
 * updateIcon使用時：const favorite = reactive({active: false})    
 * sortFavoriteList使用時：const favorite = reactive({favorites: [], others: [], all:[]})
 * @param category カテゴリー
 * @param slug スラグ
 */
export default function useFavorites({favorite, category, slug} = {}){

  const stores = {
    'bucket' : useStore(),
    'favoriteBrands' : useFavoriteBrandsStore(),
    'favoriteShops' : useFavoriteShopsStore(),
    'checkedBrands' : useCheckedBrandsStore(),
    'checkedShops' : useCheckedShopsStore(),
  }

  const bucketStore = stores.bucket
  const favoriteStore = stores[`favorite${capitalize(category)}s`]
  const checkedStore = stores[`checked${capitalize(category)}s`]

  /**
   * アイコンの状態の切り替え
   * @function
   */
  const updateIcon = () => {
    const favorites = favoriteStore.getList
    favorite.active = favorites.includes(slug)
  }

  /**
   * ボタンのクリックで、お気に入りリストを更新
   * @function
   * @param {MouseEvent} e マウスイベント
   */
  const updateFavoriteList = (e) => {
    const target = e.target.closest('.btn-toggle-star')
    if(!target) return
    const slug = target.getAttribute('slug')
    favoriteStore.getList.includes(slug) ? favoriteStore.removeItem(slug) : favoriteStore.addItem(slug)
    setCookie(`af_favorite_${category}s`, favoriteStore.getList, 60*60*24*30)
  }

  /**
   * お気に入りリストを分類して更新    
   * favorite.favorites: お気に入りのみのリスト    
   * favorite.others: お気に入り以外のリスト    
   * favorite.all: お気に入りを前に、お気に入り以外を後ろに並べたリスト    
   * @function
   */
  const sortFavoriteList = () => {
    const all = bucketStore[`get${capitalize(category)}List`]
    const keys = favoriteStore.getList
    const key = `${category}Slug`
    if(favorite.favorites){
      checkFavorite()
      favorite.favorites = getFavorites(all, keys, key)
    }
    if(favorite.others){
      favorite.others = getNonFavorites(all, keys, key)
    }
    if(favorite.all){
      favorite.all = [...getFavorites(all, keys, key), ...getNonFavorites(all, keys, key)]
    }
  }

  /**
   * 「お気に入りを選択」のチェックボックス選択時の処理
   */
  const checkFavorite = () => {
    if(checkedStore.getList.includes('favorite')){
      checkedStore.updateList(favoriteStore.getList)
      checkedStore.addItem('favorite')
    }
  }

  /**
   * お気に入りを取得
   */
  const getFavorites = (list, keys, key) => {
    return list.filter((item) => keys.filter((val) => val === item[key]).length)
  }

  /**
   * お気に入り以外を取得
   */
  const getNonFavorites = (list, keys, key) => {
    return list.filter((item) => keys.filter((val) => val === item[key]).length === 0)
  }

  /**
   * サブスクライブ用（favoriteStoreのstateに変更があった際にcallbackを実行）
   * @function
   * @param {Function} callback コールバック関数
   */
  const subscribeFavoriteList = (callback) => {
    favoriteStore.$subscribe(() => {
      callback()
    })
  }

  return {updateIcon, updateFavoriteList, sortFavoriteList, subscribeFavoriteList}

}